<div class="container mat-form-field-container">
  <sales-ui-opportunity-name></sales-ui-opportunity-name>
  <sales-ui-expected-close-selector></sales-ui-expected-close-selector>
  <sales-ui-contract-duration-selector></sales-ui-contract-duration-selector>
  <sales-ui-assignee-selector></sales-ui-assignee-selector>
  <sales-ui-subscribers-selector></sales-ui-subscribers-selector>
  <sales-ui-pipeline-selector></sales-ui-pipeline-selector>
  <sales-ui-update-type-selector></sales-ui-update-type-selector>
</div>
